import NotImplemented from '@/components/common/not-implemented';

export default function MediaFilesForm() {
  return <NotImplemented label="Media Files" />;
}
